import { Preference } from '@piwikpro/user-preferences';

export const USER_GROUP_MEMBERSHIPS_LIST_ID = 'UserGroupMemberships';
export const ADD_USER_TO_GROUP_LIST_ID = 'AddUserToGroup';

export const readListLimit = (userPreferences: any, listId: string, fallback: number): number => {
  const preference = new Preference(listId, userPreferences.load(), listId);
  const limit = preference.getFromScope('limit');

  return typeof limit === 'number' && limit > 0 ? limit : fallback;
};

export const persistListLimit = (userPreferences: any, listId: string, limit: number): void => {
  const preference = new Preference(listId, userPreferences.load(), listId);
  preference.addIntoScope('limit', limit);
  userPreferences.persist(preference);
};
